<template>
  <div class="container">
    <div class="pageTitle">站内信</div>

    <ul class="box">
      <li>
        <ul v-for='(v,k) in lis' :key='k'>
            <li  @click="readMessage('store_order',v.sn)" class="red" v-if='v.inmail_type==1'>有新的门店订单需要处理！</li>
            <li  @click="readMessage('requisitionManage',v.sn)" class="red"  v-if='v.inmail_type==4'>有调拨单需要处理！</li>
            <li  @click="readMessage('next_order',v.sn)"  class="red"  v-if='v.inmail_type==5'>有新的下级订单需要处理！</li>
            <li  @click="readMessage('announcement',v.sn)"  v-if='v.inmail_type==2'>有新的公告请前往查看</li>
            <li  @click="readMessage('library',v.sn)" v-if='v.inmail_type==3'>有新的文件可以下载!</li>
            <li  @click="readMessage('rebate',v.sn)" v-if='v.inmail_type==6'>您有新的返利结算记录,可前往查看</li>
            <li  @click="readMessage('rebate',v.sn)"  v-if='v.inmail_type==9'>你的账户有新的返利到账,可前往查看</li>
            <li  @click="readMessage('instockManage',v.sn)" v-if='v.inmail_type==7'>您有新的货品待入库，可前往查看！</li>
            <li  @click="readMessage('myorder',v.sn)"  v-if='v.inmail_type==8'>您有新的订单待收货，可前往查看！</li>
            <li  @click="readMessage('myorder',v.sn)"  v-if='v.inmail_type==10'>您的订单已提前截单，可前往查看！</li>
         
        </ul>
      </li>
      <li class="nothing" v-if='lis.length==0'>
          <div>
            暂无新消息
          </div>
      </li>
    </ul>
   
  </div>
</template>
<script>
export default {
  name: "message",
  data() {
    return {
      lis: []
    };
  },
  methods: {
    init() {
      this.$get("logistics", "/inmails").then(res => {
        this.lis = res.data;
      });
    },
    readMessage(route,sn){
      this.$post('logistics','/inmails.reads',{
        inmail_sns:sn
      }).then(res=>{
          this.$router.push({
            name:route
          })
      })
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #eee;
  min-height: 400px;
  padding: 15px;
  li {
    line-height: 20px;
    margin-bottom: 15px;
    cursor: pointer;
  }
}
.red {
  color: #f04635;
}
.nothing{
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
}
</style>

